import { render, staticRenderFns } from "./VideoFileSelect.vue?vue&type=template&id=7a2631ce&scoped=true"
import script from "./VideoFileSelect.vue?vue&type=script&lang=js"
export * from "./VideoFileSelect.vue?vue&type=script&lang=js"
import style0 from "./VideoFileSelect.vue?vue&type=style&index=0&id=7a2631ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2631ce",
  null
  
)

export default component.exports